type RelativeDatePeriod = 'days' | 'months' | 'years';
type RelativeDateDirection = 'ago' | 'from now';

// weeks is currently not supported, but could be implemented later
export const relativeDatePeriods = ['days', 'months', 'years'];
export const relativeDateDirections = ['ago', 'from now'];

export const createRelativeDateValue = (
  value: string,
  period: RelativeDatePeriod,
  direction: RelativeDateDirection,
): Record<string, string> => {
  if (value != null && Number.isNaN(parseInt(value, 10)))
    throw new Error(
      `RelativeDateExpression 'value' parameter must be parseable as an integer, received ${value}`,
    );
  if (
    period != null &&
    (typeof period !== 'string' || !relativeDatePeriods.includes(period))
  )
    throw new Error(
      `RelativeDateExpression 'periods' parameter must be a valid RelativeDatePeriod, received ${period}`,
    );
  if (
    direction != null &&
    (typeof direction !== 'string' ||
      !relativeDateDirections.includes(direction))
  )
    throw new Error(
      `RelativeDateExpression 'direction' parameter must be a valid RelativeDateDirection, received ${direction}`,
    );

  return {
    direction,
    period,
    type: 'relativeDate',
    value,
  };
};
